export default "__VITE_ASSET__CQoFXadQ__"